
"use strict"

import { init as search } from './search'
import { init as savedJobs } from './savedJobs'
import { init as latestJobs } from './latestJobs'

import { init as apply } from './forms/apply'
import { init as applyStages } from './forms/applyStages'
import { init as applyReview } from './forms/applyReview'
import { init as register } from './forms/register'
import { init as registerStages } from './forms/registerStages'
import { init as registerReview } from './forms/registerReview'
import { init as eventForm } from './forms/eventForm'

import { init as navigation } from './components/navigation'
import { init as companyNavigation } from './components/companyNavigation'
import expand from './components/expand'
import carousel from './components/imageCarousel'
import galleryCarousel from './components/galleryCarousel'
import clientLogoCarousel from './components/clientLogoCarousel'
import selectAutosubmit from './components/selectAutosubmit'
import companyJobsPane from './components/companyJobsPane'
import contactMap from './components/contactMap.js';


savedJobs()
latestJobs()
search()
apply()
applyStages()
applyReview()
register()
registerStages()
registerReview()
eventForm()

companyJobsPane()
navigation()
companyNavigation()
carousel()
galleryCarousel()
clientLogoCarousel()
contactMap()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

expand('.js-expand-button', (open, button, content) => {
	button.innerHTML = button.innerHTML.replace(/^(\+|\–)/, open ? '–' : '+')
})

selectAutosubmit('.js-select-autosubmit')